import React, { useMemo, useState } from 'react';
import styles from './ActionCenterMessageDetail.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { User } from '../../../../graphql/graphql';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	conversationMembers: User[];
	sender?: User;
}

const ActionCenterMessageRecipients: React.FC<Props> = ({
	conversationMembers = [],
	sender,
}) => {
	const [showAllRecipients, setShowAllRecipients] = useState(false);
	const { t } = useTranslation();

	const messageRecipients = useMemo(() => {
		return conversationMembers.reduce<string[]>(
			(recipients, conversationMember) => {
				const userId = conversationMember.id;
				if (userId !== sender?.id) {
					if (conversationMember.profile?.fullName) {
						recipients.push(conversationMember.profile.fullName);
					}
				}
				return recipients;
			},
			[],
		);
	}, [conversationMembers, sender?.id]);

	const firstRecipient = messageRecipients[0];

	const messageAllRecipients = messageRecipients.join(', ');

	const totalRecipients = messageRecipients.length;

	const hiddenRecipientsCount = totalRecipients - 1;

	return (
		<div className={styles.from}>
			<Text tx='base.toWho' firstUpper inline colon />{' '}
			{showAllRecipients ? (
				<>
					{messageAllRecipients}{' '}
					<LinkButton
						title='base.hide'
						theme={Theme.BLUE}
						onClick={() => setShowAllRecipients(false)}
					/>
				</>
			) : (
				<>
					{firstRecipient}{' '}
					{hiddenRecipientsCount > 0 && (
						<LinkButton
							title={`+${hiddenRecipientsCount} ${t('base.next')}`}
							theme={Theme.BLUE}
							onClick={() => setShowAllRecipients(true)}
						/>
					)}
				</>
			)}
		</div>
	);
};

export default ActionCenterMessageRecipients;
